<section class="flex flex-col md:flex-row text-gray-500">
  <div class="basis-7/12 bg-beige py-12 lg:py-24 px-5 md:px-28">
    <h1 [innerHTML]="'giftCards100Ciels' | translate" class="text-6xl font-semibold text-100cielsGift-100"></h1>
    <p [innerHTML]="'easyToGive' | translate" class="font-normal text-2xl mt-4 mb-9"></p>

    <p
      class="font-semibold text-xl mt-12 mb-6">{{ 'centerValidity' | translate }}</p>
    <p [innerHTML]="'giftCardAdvantages' | translate" class="pb-10"></p>

    <p class="font-semibold text-xl mb-6" id="formStart">{{ 'amountChoice' | translate }}</p>
    <div class="flex flex-wrap gap-4">
      @for (giftCertificate of productService.giftCertificates(); track giftCertificate.id) {
        <label
          [for]="giftCertificate.id"
          class="font-semibold rounded-full py-2 px-6 hover:bg-100cielsGift-100 hover:text-white cursor-pointer"
          [ngClass]="giftCertificate.id === product.value ? 'bg-100cielsGift-100 text-white' : 'bg-white'">
          <input type="radio" [value]="giftCertificate.id" class="sr-only" [formControl]="product"
                 [id]="giftCertificate.id">
          <span>{{ siteService.price(giftCertificate.id).price | currency }}</span>
        </label>
      }
    </div>
    @if (product.value) {
      <app-gift-form [gift]="gift" [editOnLoad]="true" [canBeSubmitted]="product.valid"
                     (giftFormSubmitted)="giftFormSubmitted($event)"></app-gift-form>
    }

    <p class="font-medium text-lg mt-14 mb-9 md:px-10">{{ 'otherQuestions' | translate }}
      <a [routerLink]="['/help']" class="underline">{{ 'helpCenter' | translate }}</a>
    </p>
  </div>
  <div class="basis-5/12 bg-beige md:bg-gray-200 md:bg-opacity-70 py-12 lg:py-24 px-5 md:px-28">
    <div class="">
      <img alt="" class="w-full" height="1185" ngSrc="assets/images/carteCadeau.webp" priority width="1177">
    </div>
    <h2 class="font-semibold text-xl" id="anchor">{{ 'giftCardSummary' | translate }}</h2>
    <p class="font-medium text-lg mt-14 mb-8">{{ 'product' | translate: {quantity: gifts().length.toString()} }}</p>
    <!-- Ligne du panier --->
    @for (item of gifts(); track item) {
      <div class="flex gap-4 items-center">
        <app-cart-item-line class="grow" [item]="{item: item, quantity: 1}"></app-cart-item-line>
        @if (new) {
          <button
            (click)="edit(item)"
            (keyup.enter)="emulateClick($event)"
            role="button"
            tabindex="0">
            <img alt="" width="30" height="30" ngSrc="assets/icons/dark/edit.svg" class="w-6 h-6 md:w-8 md:h-8">
          </button>
          <button
            (click)="cartService.remove(item)"
            (keyup.enter)="emulateClick($event)"
            role="button"
            tabindex="0">
            <img alt="" width="36" height="36" ngSrc="assets/icons/dark/trashcan.svg" class="w-6 h-6 md:w-8 md:h-8">
          </button>
        }
      </div>
    }

    <div class="py-7 border-t border-gray-300">
      <div class="flex justify-between items-center font-semibold text-lg">
        <p>{{ 'totalWithTaxes' | translate }}</p>
        <p>{{ total() | currency }}</p>
      </div>
      <div class="flex justify-between items-center text-sm mt-2">
        <p>{{ 'includingVAT' | translate }} 20%</p>
        <p>{{ taxes() | currency }}</p>
      </div>
    </div>
    <a [routerLink]="['/checkout']" appHoverGradient class="big-btn bg-100cielsGift-100">
      {{ 'goToCheckout' | translate }}
    </a>
  </div>
</section>
